import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { Target } from "lucide-react";
import {
  NA_PRIMARY,
  NA_SECONDARY,
  naReadableText,
  naGradientLine,
  naDarkCardBase,
  naCardBgHover,
  onDarkCardLeave,
} from "./naSectionTokens";
import { EVENT_LOCATION } from "../../constants";

function NAClosingVisionSection() {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;

  return (
    <section className="section py-5" style={{ background: "transparent", position: "relative", zIndex: 1 }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            <Card
              style={{
                ...naDarkCardBase,
                border: `1px solid ${NA_PRIMARY}40`,
                borderRadius: "20px",
                padding: size ? "2.5rem" : "1.75rem",
                overflow: "hidden",
                position: "relative",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = naCardBgHover;
              }}
              onMouseLeave={onDarkCardLeave}
            >
              <div className="d-flex align-items-start mb-3" style={{ gap: "1.1rem" }}>
                <div
                  style={{
                    width: size ? 56 : 48,
                    height: size ? 56 : 48,
                    minWidth: size ? 56 : 48,
                    borderRadius: "16px",
                    background: `linear-gradient(145deg, ${NA_PRIMARY}30, ${NA_SECONDARY}20)`,
                    border: `2px solid ${NA_PRIMARY}55`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Target size={size ? 28 : 24} strokeWidth={2} style={{ color: NA_PRIMARY }} />
                </div>
                <h2
                  className="text-white mb-0"
                  style={{
                    fontSize: size ? "2rem" : "1.55rem",
                    fontWeight: 700,
                    letterSpacing: "0.05em",
                    textTransform: "uppercase",
                    color: NA_PRIMARY,
                    lineHeight: 1.2,
                    ...naReadableText,
                  }}
                >
                  North America Digital Twin 2026
                </h2>
              </div>
              <p
                className="mb-0"
                style={{
                  fontSize: size ? "1.18rem" : "1.05rem",
                  lineHeight: 1.8,
                  ...naReadableText,
                }}
              >
                Join leaders shaping intelligent infrastructure, smart cities, and connected urban
                systems — from policy and planning to delivery and operations — at {EVENT_LOCATION}{" "}
                this August.
              </p>
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  ...naGradientLine,
                  opacity: 0.85,
                }}
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default NAClosingVisionSection;
